import { Modal } from './src/Modal';
import { Step } from './src/Step';
import { Panel } from './src/Panel';
import { Title } from './src/Title';
import { Subtitle } from './src/Subtitle';
import { Info } from './src/Info';
import { Main } from './src/Main';
import { Footer } from './src/Footer';
import { Controls } from './src/Controls';
import { ControlBtn } from './src/ControlBtn';
import { Features, FeaturesItem } from './src/Features';

const Auth = {};

Auth.Modal = Modal;
Auth.Step = Step;
Auth.Panel = Panel;
Auth.Title = Title;
Auth.Subtitle = Subtitle;
Auth.Info = Info;
Auth.Main = Main;
Auth.Footer = Footer;
Auth.Controls = Controls;
Auth.ControlBtn = ControlBtn;
Auth.Features = Features;
Auth.FeaturesItem = FeaturesItem;

export { Auth };
